import { useState } from 'react'
import './ResponsesSectionHeader.scoped.sass'
import { SortMenu } from '@/components/SortMenu/SortMenu'

export function ResponsesSectionHeader ({ responsesCount, showMoreButtonEvent }) {
  const [viewLess, setViewLess] = useState(false)
  function showHideResponses () {
    setViewLess(!viewLess)
    showMoreButtonEvent()
  }
  if (responsesCount <= 1) return []
  return (
    <section className="responses-section-header">
      <div className="container-responses">
        <div className="left">
          <div className='show-all-responses' onClick={showHideResponses}>
            {!viewLess ? `View all Responses (${responsesCount})` : 'Hide responses'}
          </div>
        </div>
        <div className="right">
          <SortMenu sortValues={['Newest first', 'Unread']} />
        </div>
      </div>
    </section>
    // <section className="ResponsesSectionHeader">
    //   <div className="-all-responses" onClick={showHideResponses}>
    //     {!viewLess ? 'View all Responses' : 'Hide responses'}
    //   </div>
    //   <div className="-thread">Thread ({props.responsesCount})</div>
    // </section>
  )
}
